<div class="grid">
    <div>
        <app-classification-banner *ngIf="configService.enableClassificationBanner" [text]="configService.classificationBannerText"
                                   [color]="configService.classificationBannerColor"></app-classification-banner>
    </div>
    <div class="g-max-height g-display-block">
        <app-toaster></app-toaster>
        <app-iframe></app-iframe>
        <router-outlet *ngIf="appInitialized$ | async"></router-outlet>
    </div>
    <app-classification-banner *ngIf="configService.enableClassificationBanner" [text]="configService.classificationBannerText"
                               [color]="configService.classificationBannerColor"></app-classification-banner>

    <ag-grid-angular
            class="export-grid"
            (gridReady)="setExportGridAPI($event)"
    ></ag-grid-angular>
</div>
